import React from "react";
import PropTypes from "prop-types";

const ButtonHeader = ({
  handleClick,
  ariaLabel,
  dataModal,
  buttonContent,
  className,
}) => {
  return (
    <button
      onClick={handleClick}
      type="button"
      aria-label={ariaLabel}
      data-modal={dataModal}
      className={className}
    >
      {buttonContent}
    </button>
  );
};

ButtonHeader.defaultProps = {
  className: "",
};

ButtonHeader.propTypes = {
  handleClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  dataModal: PropTypes.string.isRequired,
  buttonContent: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ButtonHeader;
